export const NEW_PASSWORD_CHALLENGE = 'NEW_PASSWORD_REQUIRED';
export const SMS_MFA_CHALLENGE = 'SMS_MFA';
export const COGNITO_KEY_PREFIX = 'CognitoIdentityServiceProvider';

export const NOT_AUTHORIZED_CODE = 'NotAuthorizedException';
export const USER_NOT_FOUND_CODE = 'UserNotFoundException';

// 3 mins, same time as the sms expiration timeout
export const SMS_MFA_TIMEOUT = 180000;
